var _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _path7, _g, _path8, _rect3, _rect4, _path9, _path10, _path11, _g2, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompressPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 159,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1395 78.7158C14.2494 58.5052 38.3189 43.2752 66.7157 33.7036C95.3056 24.0669 131.3 18.6511 164.075 28.1778C195.098 37.1953 206.435 58.469 217.285 77.4696C227.178 94.7956 239.339 115.202 220.957 127.794C203.642 139.654 169.178 129.687 140.969 129.745C114.864 129.798 89.1158 137.328 66.2025 128.109C37.4903 116.557 14.0352 97.8996 14.1395 78.7158Z",
    fill: "#FAF9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.214 69.4545C139.214 69.9736 138.793 70.3945 138.274 70.3945L127.94 70.3945C127.421 70.3945 127 70.8153 127 71.3345L127 87.2955C127 87.8147 127.421 88.2355 127.94 88.2355L138.274 88.2355C138.793 88.2355 139.214 88.6564 139.214 89.1755L139.214 93.4321C139.214 94.308 140.307 94.7079 140.872 94.039L152.807 79.9219C153.103 79.5715 153.103 79.0585 152.807 78.7081L140.872 64.591C140.307 63.9221 139.214 64.322 139.214 65.1979L139.214 69.4545Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.449 114.129V45.0184C167.449 43.035 169.008 41.4485 170.906 41.4485H211.199L227.504 58.2248V114.129C227.504 116.112 225.945 117.699 224.047 117.699H170.906C169.009 117.699 167.449 116.113 167.449 114.129Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 0.897059
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 174.619,
    y: 92.5809,
    width: 45.7143,
    height: 18.8382,
    rx: 1.96071,
    fill: "#D2294B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 174.619,
    y: 92.5809,
    width: 45.7143,
    height: 18.8382,
    rx: 1.96071,
    stroke: "#D2294B",
    strokeWidth: 0.897059
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.635 106.015V97.9846H190.282C191.173 97.9846 191.86 98.2124 192.343 98.6681C192.826 99.1161 193.068 99.7427 193.068 100.548C193.068 101.353 192.826 101.983 192.343 102.439C191.86 102.894 191.173 103.122 190.282 103.122H188.39V106.015H186.635ZM188.39 101.755H189.987C190.916 101.755 191.38 101.353 191.38 100.548C191.38 99.7579 190.916 99.363 189.987 99.363H188.39V101.755Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.156 106.015V97.9846H197.282C198.641 97.9846 199.694 98.3339 200.442 99.0326C201.189 99.7237 201.563 100.711 201.563 101.994C201.563 103.278 201.189 104.269 200.442 104.967C199.694 105.666 198.641 106.015 197.282 106.015H194.156ZM195.911 104.569H197.18C198.879 104.569 199.728 103.711 199.728 101.994C199.728 100.286 198.879 99.4313 197.18 99.4313H195.911V104.569Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.927 106.015V97.9846H208.318V99.363H204.682V101.322H208.069V102.701H204.682V106.015H202.927Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.038 54.0967V42.1088L226.942 57.5157H215.331C213.527 57.5157 212.038 55.9996 212.038 54.0967Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 0.897059
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.7 66.425H213.3C214.004 66.425 214.575 66.9958 214.575 67.7V68.55C214.575 69.2542 214.004 69.825 213.3 69.825H182.7C181.996 69.825 181.425 69.2542 181.425 68.55V67.7C181.425 66.9958 181.996 66.425 182.7 66.425Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7 74.925H213.3C214.004 74.925 214.575 75.4958 214.575 76.2V77.05C214.575 77.7542 214.004 78.325 213.3 78.325H182.7C181.996 78.325 181.425 77.7542 181.425 77.05V76.2C181.425 75.4958 181.996 74.925 182.7 74.925Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7 83.425H213.3C214.004 83.425 214.575 83.9958 214.575 84.7V85.55C214.575 86.2542 214.004 86.825 213.3 86.825H182.7C181.996 86.825 181.425 86.2542 181.425 85.55V84.7C181.425 83.9958 181.996 83.425 182.7 83.425Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.85
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6397 128.298V29.7312C24.6397 26.9024 26.8636 24.6397 29.5703 24.6397H87.0383L110.293 48.5665V128.298C110.293 131.127 108.069 133.39 105.363 133.39H29.5703C26.8647 133.39 24.6397 131.128 24.6397 128.298Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.8668,
    y: 97.566,
    width: 65.199,
    height: 26.8676,
    rx: 2.79643,
    fill: "#D2294B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.8668,
    y: 97.566,
    width: 65.199,
    height: 26.8676,
    rx: 2.79643,
    stroke: "#D2294B",
    strokeWidth: 1.27941
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0039 116.727V105.273H57.2053C58.476 105.273 59.456 105.598 60.1452 106.248C60.8344 106.887 61.179 107.78 61.179 108.928C61.179 110.076 60.8344 110.975 60.1452 111.625C59.456 112.275 58.476 112.6 57.2053 112.6H54.5077V116.727H52.0039ZM54.5077 110.651H56.7853C58.1099 110.651 58.7722 110.076 58.7722 108.928C58.7722 107.802 58.1099 107.239 56.7853 107.239H54.5077V110.651Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7307 116.727V105.273H67.1891C69.1275 105.273 70.6297 105.771 71.6959 106.768C72.762 107.753 73.295 109.161 73.295 110.992C73.295 112.822 72.762 114.236 71.6959 115.232C70.6297 116.229 69.1275 116.727 67.1891 116.727H62.7307ZM65.2345 114.663H67.0437C69.4667 114.663 70.6782 113.44 70.6782 110.992C70.6782 108.555 69.4667 107.336 67.0437 107.336H65.2345V114.663Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2401 116.727V105.273H82.9291V107.239H77.7439V110.033H82.5737V111.999H77.7439V116.727H75.2401Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 56.6248H91C91.7513 56.6248 92.3603 57.2338 92.3603 57.9851V61.6005C92.3603 62.3517 91.7513 62.9608 91 62.9608H45C44.2487 62.9608 43.6397 62.3517 43.6397 61.6005V57.9851C43.6397 57.2338 44.2487 56.6248 45 56.6248Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 69.3172H91C91.7513 69.3172 92.3603 69.9262 92.3603 70.6775V74.2928C92.3603 75.0441 91.7513 75.6531 91 75.6531H45C44.2487 75.6531 43.6397 75.0441 43.6397 74.2928V70.6775C43.6397 69.9262 44.2487 69.3172 45 69.3172Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 82.0096H91C91.7513 82.0096 92.3603 82.6186 92.3603 83.3699V86.9852C92.3603 87.7365 91.7513 88.3455 91 88.3455H45C44.2487 88.3455 43.6397 87.7365 43.6397 86.9852V83.3699C43.6397 82.6186 44.2487 82.0096 45 82.0096Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2349 42.6789V25.5814L109.491 47.5552H92.9312C90.3578 47.5552 88.2349 45.3929 88.2349 42.6789Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompressPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/compress_pdf.8c62ebc10afb032d6df414e72e9cc1fd.svg";